import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { FileType } from './file-type.interface';
import { FileTypeService } from './file-type.service';
const service = new FileTypeService();

export interface FileTypeState {
   fileTypes: Array<FileType>;
}

const FileTypeStore: Module<FileTypeState, StoreState> = {
   namespaced: true,
   state: {
      fileTypes: [],
   },
   getters: {},
   mutations: {
      SET_FILE_TYPES(state, fileTypes: Array<FileType>) {
         state.fileTypes = fileTypes;
      },
   },
   actions: {
      async getFileTypes({ commit }) {
         const fileTypes = await service.getFileTypes();
         commit('SET_FILE_TYPES', fileTypes.data);

         return fileTypes;
      },
   },
};

export default FileTypeStore;
